import {
    ON_LOAD_EVENTS,
    GET_COUNTRY_LIST,
    INVITE_PARTICIPANT,
    ISCOMPANY_AVAILABLE,
    PRIVACY_POLICY,
    ADD_SESSION_STATS,
    NOT_RESET_EVENTS_ON_ENDCALL,
    IS_ROOM_PARTICIPANT_EXCEED,
} from "../reducers/onLoadFunction-reducer";
import onLoadFunctionService from "../services/onLoadFunctionService";
import CustomToast from "../components/UI/customToast";
import { setPortalNames } from "./languageAction";
import { PORTAL_NAME_CHANGE_FROM } from "../constants/Constants";
import { dispatchAction } from "../shared/function";
import { LogFirebase } from "../services/firestore";

//#region is comapany available
const isCompanyAvailableStart = () => dispatchAction(ON_LOAD_EVENTS.ISCOMPANY_AVAILABLE, ISCOMPANY_AVAILABLE.START);
const isCompanyAvailableSuccess = (data) => dispatchAction(ON_LOAD_EVENTS.ISCOMPANY_AVAILABLE, ISCOMPANY_AVAILABLE.SUCCESS, data);
const isCompanyAvailableError = (error) => dispatchAction(ON_LOAD_EVENTS.ISCOMPANY_AVAILABLE, ISCOMPANY_AVAILABLE.ERROR, error);

export const checkIsCompanyAvailable = (req) => async (dispatch) => {
    dispatch(isCompanyAvailableStart());
    onLoadFunctionService
        .checkIsCompanyAvailable(req)
        .then((response) => {
            dispatch(isCompanyAvailableSuccess(response));
        })
        .catch((error) => {
            CustomToast.error(error);
            dispatch(isCompanyAvailableError(error));
        });
};
//#endregion is comapany available

//#region privacy policy API
const privacyPolicyStart = () => dispatchAction(ON_LOAD_EVENTS.PRIVACY_POLICY, PRIVACY_POLICY.START);
const privacyPolicySuccess = (data) => dispatchAction(ON_LOAD_EVENTS.PRIVACY_POLICY, PRIVACY_POLICY.SUCCESS, data);
const privacyPolicyError = (error) => dispatchAction(ON_LOAD_EVENTS.PRIVACY_POLICY, PRIVACY_POLICY.ERROR, error);

export const getPrivacyPolicy = (req) => async (dispatch) => {
    dispatch(privacyPolicyStart());
    onLoadFunctionService
        .getPrivacyPolicy(req)
        .then((response) => {
            dispatch(privacyPolicySuccess(response));
            // Updating Portal names
            dispatch(setPortalNames(PORTAL_NAME_CHANGE_FROM.PRIVACY_POLICY, response));
        })
        .catch((error) => {
            CustomToast.error(error);
            dispatch(privacyPolicyError(error));
        });
};
//#endregion privacy policy API

//#region get country list
const getCountryListStart = () => dispatchAction(ON_LOAD_EVENTS.GET_COUNTRY_LIST, GET_COUNTRY_LIST.START);
const getCountryListSuccess = (data) => dispatchAction(ON_LOAD_EVENTS.GET_COUNTRY_LIST, GET_COUNTRY_LIST.SUCCESS, data);
const getCountryListError = (error) => dispatchAction(ON_LOAD_EVENTS.GET_COUNTRY_LIST, GET_COUNTRY_LIST.ERROR, error);

export const getCountryList = (req) => async (dispatch) => {
    dispatch(getCountryListStart());
    onLoadFunctionService
        .getCountryList()
        .then((response) => {
            dispatch(getCountryListSuccess(response));
        })
        .catch((error) => {
            CustomToast.error(error);
            dispatch(getCountryListError(error));
        });
};
//#endregion get country list

//#region invite participant API
const inviteParticipantStart = () => dispatchAction(ON_LOAD_EVENTS.INVITE_PARTICIPANT, INVITE_PARTICIPANT.START);
const inviteParticipantSuccess = (data) => dispatchAction(ON_LOAD_EVENTS.INVITE_PARTICIPANT, INVITE_PARTICIPANT.SUCCESS, data);
const inviteParticipantError = (error) => dispatchAction(ON_LOAD_EVENTS.INVITE_PARTICIPANT, INVITE_PARTICIPANT.ERROR, error);
export const inviteParticipantReset = () => dispatchAction(ON_LOAD_EVENTS.INVITE_PARTICIPANT, INVITE_PARTICIPANT.RESET);

export const inviteParticipant = (req) => async (dispatch) => {
    dispatch(inviteParticipantStart());
    onLoadFunctionService
        .inviteParticipant(req)
        .then((response) => {
            dispatch(inviteParticipantSuccess(response));
        })
        .catch((error) => {
            CustomToast.error(error);
            dispatch(inviteParticipantError(error));
        });
};
//#endregion invite participant API

//#region add session stats API
const addSessionStatsStart = () => dispatchAction(ON_LOAD_EVENTS.ADD_SESSION_STATS, ADD_SESSION_STATS.START);
const addSessionStatsSuccess = (data) => dispatchAction(ON_LOAD_EVENTS.ADD_SESSION_STATS, ADD_SESSION_STATS.SUCCESS, data);
const addSessionStatsError = (error) => dispatchAction(ON_LOAD_EVENTS.ADD_SESSION_STATS, ADD_SESSION_STATS.ERROR, error);

export const sessionStats = (req) => async (dispatch) => {
    dispatch(addSessionStatsStart());
    onLoadFunctionService
        .sessionStats(req)
        .then((response) => {
            dispatch(addSessionStatsSuccess(response));
        })
        .catch((error) => {
            LogFirebase("_callStatsAdd_error", error?.message);
            dispatch(addSessionStatsError(error));
        });
};
//#endregion add session stats API

export const hanldeRoomParticipantExceed = (payload) => (dispatch) => {
    dispatch(dispatchAction(NOT_RESET_EVENTS_ON_ENDCALL.IS_ROOM_PARTICIPANT_EXCEED, IS_ROOM_PARTICIPANT_EXCEED.SUCCESS, payload));
};
